import React, { useState } from 'react';
import PropTypes from 'prop-types';
import OfferAssetListSummary from './OfferAssetListSummary';
import DirectionsCar from '@mui/icons-material/DirectionsCar';
import { CollapseCard } from '@totalsoft/rocket-ui';

export const OfferAssetItemComponent = ({ asset, onEdit, onDeleteAsset, assetImage, showDeleteButton, deleting, idx }) => {
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);

  const onDelete = event => {
    event.preventDefault();
    event.stopPropagation();
    setDeleteConfirmationModal(true);
  };
  return (
    <CollapseCard
      id={'offerAssetItemCard_' + idx}
      icon={DirectionsCar}
      title={`${asset.assetTypeName} x ${asset.quantity}`}
      onToggle={onEdit(asset.documentDetailId, asset.siteId)}
      hasCustomExpandIcon
      toggleOnHeaderClick
      subheader={
        <OfferAssetListSummary
          asset={asset}
          idx={idx}
          deleteConfirmationModal={deleteConfirmationModal}
          setDeleteConfirmationModal={setDeleteConfirmationModal}
          assetImage={assetImage}
          onDeleteAsset={onDeleteAsset(asset)}
          showDeleteButton={showDeleteButton}
          onDelete={onDelete}
          deleting={deleting}
        />
      }
      hideSubheaderOnExpand
      content={<></>}
      showFooter={showDeleteButton}
    ></CollapseCard>
  );
};

OfferAssetItemComponent.propTypes = {
  asset: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  assetImage: PropTypes.string,
  onDeleteAsset: PropTypes.func.isRequired,
  showDeleteButton: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  idx: PropTypes.number
};

export default OfferAssetItemComponent;
